import { Controller } from "@hotwired/stimulus"

// What lands while you watch (paperwork_events/_activity_stream): a node the
// live stream inserts into the timeline, the plan strip or the sidebar's Where
// it stands, or a word it rewrites, is marked .is-fresh for a moment, so the
// paper-bot touches in globals.css (ink that writes itself in, a stamped
// verdict, a tick that pops) play for news only, never on page load.
const WATCHED = ".paperwork-events, .agent-now"
const SETTLE_MS = 800
const FRESH_MS = 2400

export default class extends Controller {
  connect() {
    this.timer = setTimeout(() => this.watch(), SETTLE_MS)
  }

  disconnect() {
    clearTimeout(this.timer)
    this.observer?.disconnect()
  }

  watch() {
    this.observer = new MutationObserver((records) => records.forEach((record) => this.mark(record)))
    const options = { childList: true, subtree: true, characterData: true }
    // The timeline itself, and the sidebar's Where it stands. Its status line
    // is replaced whole by its broadcast, so the observer watches its holder.
    this.observer.observe(this.element, options)
    const now = document.querySelector(".agent-now")
    if (now?.parentElement && !this.element.contains(now)) this.observer.observe(now.parentElement, options)
  }

  mark(record) {
    const nodes = record.type === "characterData" ? [record.target.parentElement] : [...record.addedNodes]
    nodes.forEach((node) => {
      if (!(node instanceof Element) || !node.closest(WATCHED) && !node.matches?.(WATCHED)) return
      // A ticking clock is not news.
      if (node.closest("[data-controller~='elapsed'], [data-controller~='task-age']")) return
      node.classList.add("is-fresh")
      setTimeout(() => node.classList.remove("is-fresh"), FRESH_MS)
    })
  }
}
